<p-dialog header="Registrar Carnet Profesional" [visible]="display()" [modal]="true" [closable]="false"
          appendTo="body"
          [style]="{width: '35vw'}">
    <div class="p-fluid">
        <div class="p-field">
            <label for="institucion">Institución</label>
            <p-dropdown
                id="institucion"
                required="true"
                [options]="instituciones"
                [(ngModel)]="selected.institucion"
                optionLabel="name"
                placeholder="Seleccionar Institución"
                [styleClass]="selected.institucion ? '' : 'p-invalid'">
            </p-dropdown>
        </div>
        <div class="p-field">
            <label for="numDocumento">Número Documento</label>
            <input id="numDocumento" type="text" required="true" pInputText [pTooltip]="'DUI'"
                   [(ngModel)]="selected.numDocumento" [class.p-invalid]="!selected.numDocumento"/>
        </div>
        <div class="p-field">
            <label for="profesion">Profesion</label>
            <input id="profesion" type="text" required="true" pInputText [pTooltip]="'Profesion segun carnet'"
                   [(ngModel)]="selected.profesion" [class.p-invalid]="!selected.profesion"/>
        </div>
        <div class="p-field">
            <label for="nombres">Nombres</label>
            <input id="nombres" type="text" required="true" pInputText [(ngModel)]="selected.nombres"
                   [class.p-invalid]="!selected.nombres"/>
        </div>
        <div class="p-field">
            <label for="apellidos">Apellidos</label>
            <input id="apellidos" type="text" required="true" pInputText [(ngModel)]="selected.apellidos"
                   [class.p-invalid]="!selected.apellidos"/>
        </div>
        <div class="p-field">
            <label for="numResolucion">Número Resolución</label>
            <input id="numResolucion" type="text" required="true" pInputText
                   [pTooltip]="'Numero de carnet o resolucion'"
                   [(ngModel)]="selected.numResolucion" [class.p-invalid]="!selected.numResolucion"/>
        </div>
        <div class="p-field">
            <label for="fechaResolucion">Fecha Resolución</label>
            <p-inputMask
                [pTooltip]="'Fecha resolucion o emision de carnet'"
                [(ngModel)]="selected.fechaResolucion"
                required="true"
                mask="99/99/9999"
                placeholder="dd/mm/yyyy"
                slotChar="dd/mm/yyyy" [class.p-invalid]="!selected.fechaResolucion"/>
        </div>
        <div class="p-field">
            <label for="fechaVencimiento">Fecha Vencimiento</label>
            <p-inputMask
                [pTooltip]="'Fecha vencimiento o caducidad del carnet'"
                [(ngModel)]="selected.fechaVencimiento"
                required="true"
                mask="99/99/9999"
                placeholder="dd/mm/yyyy"
                slotChar="dd/mm/yyyy" [class.p-invalid]="!selected.fechaVencimiento"/>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex gap-3 mt-1">
            <p-button label="Cancelar" (click)="closeDlg()" icon="pi pi-times"
                      [rounded]="true" [outlined]="true"
                      styleClass="p-button-icon p-button-info w-full"
                      class="w-full"></p-button>
            <p-button label="Registrar" type="submit" (click)="create()"
                      icon="pi pi-check"
                      styleClass="p-button-rounded p-button-info w-full"
                      class="w-full"/>
        </div>
    </ng-template>
</p-dialog>
